import React from 'react'
import { YoutubePlayer } from '../youtube-player'
import styles from './index.module.scss'

type YoutubeMonitorProps = {
  youtubeId: string
}

export const YoutubeMonitor = ({ youtubeId }: YoutubeMonitorProps) => {
  return (
    <div className={`${styles.monitorFrame} mx-auto`}>
      <div className={styles.body}>
        <div className={styles.bezel}>
          <div className={styles.screen}>
            <YoutubePlayer youtubeId={youtubeId} />
          </div>
        </div>
        <div className={styles.logo}>DISPLAY</div>
        <div className={styles.powerLed}></div>
      </div>
    </div>
  )
}
